import { useEffect } from 'react';

export default function usePageMeta({ title, description, keywords } = {}) {
  useEffect(() => {
    if (title) {
      document.title = title;
      // update OG and Twitter title
      ['og:title', 'twitter:title'].forEach((prop) => {
        let tag = document.querySelector(`meta[property="${prop}"]`) || document.querySelector(`meta[name="${prop}"]`);
        if (!tag) {
          tag = document.createElement('meta');
          if (prop.startsWith('og:')) tag.setAttribute('property', prop);
          else tag.setAttribute('name', prop);
          document.head.appendChild(tag);
        }
        tag.setAttribute('content', title);
      });
    }

    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'description');
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', description);

      // also update Open Graph / Twitter
      ['og:description', 'twitter:description'].forEach((prop) => {
        let tag = document.querySelector(`meta[property="${prop}"]`) || document.querySelector(`meta[name="${prop}"]`);
        if (!tag) {
          tag = document.createElement('meta');
          if (prop.startsWith('og:')) tag.setAttribute('property', prop);
          else tag.setAttribute('name', prop);
          document.head.appendChild(tag);
        }
        tag.setAttribute('content', description);
      });
    }

    if (keywords) {
      let meta = document.querySelector('meta[name="keywords"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'keywords');
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', keywords);
    }
  }, [title, description, keywords]);
}
